const doors = {
  doors: 'Doors',
  search_door: 'Search Door',
  events: 'Events',
  notes: 'Notes',
  basic: 'Basic',
  advanced: 'Advanced',
  side_b: 'Exit Side',
  side_a: 'Entry Side',
  options: 'Options',
  schedule: 'Schedule',
  timing: 'Timing',
  user_location: 'User Location',
  access_mode: 'Access Mode',
  edit: 'Edit',
  restore_tamper_alarm: 'Restore tamper alarm',
  no_tampered_msg: 'The door is not tampered',
  lockdown_grant: 'Lockdown grant access',
  no_lockdown_msg: 'The door is not on lockdown',
  total_active_doors: 'Total active doors',
  form: {
    active: 'Active',
    type_here: 'Type here',
    controller_name: 'Controller name',
    unlock_schedule: 'Unlock schedule',
    unlock_first: 'Unlock on first access/first person to enter',
    relock_door_open: 'Relocks on door open',
    relock_door_closed: 'Relocks on door closed',
    left_open: 'Can be left open',
    double_swipe: 'Double swipe',
    classroom_mode_solo: 'Solo',
    access_mode_normal: 'Normal',
    access_mode_classroom_toggle: 'Classroom',
    access_granted: 'Access granted',
    doors_open: 'Doors open',
    unlock_time: 'Unlock time (seconds)',
    extended_unlock: 'Extended unlock (seconds)',
    open_prealarm: 'Open too long pre-alarms (seconds)',
    open_alarm: 'Open too long alarms (seconds)',
    rex: 'REX',
    reader: 'Reader',
    contact_input: 'Contact Input',
    lock: 'Lock',
    door_open: 'And even if door open',
    interlock_side: 'Interlock on this side',
    two_man_rule: '2-user access (chaperone)',
    active_schedule: 'Active schedule',
    active_schedule_explanation:
      'When the Active Schedule is active, access requires Card and keypad code. Outside of the schedule, it reverts to Card or keypad code.',
    rex_schedule: 'REX schedule',
    unlock_options: 'Unlock options',
    card_only: 'Card only',
    keypad_only: 'Keypad code only',
    card_or_keypad: 'Card or keypad code',
    card_and_keypad: 'Card and keypad code',
    none: 'None',
  },
  table: {
    door: 'DOOR',
    state: 'STATE',
    lock_status: 'LOCK STATUS',
    access_status: 'ACCESS STATUS',
  },
  legend: {
    closed: 'Closed',
    pre_alarm: 'Pre-alarm',
    alarm: 'Alarm',
    locked: 'Locked',
    unlocked: 'Unlocked',
    unlocked_schedule: 'Unlocked schedule',
    access_disabled: 'Access disabled',
    trouble: 'Trouble',
    open: 'Open',
    alarm_forced: 'Alarm / Forced',
    locked_operator: 'Lock (Override)',
    unlocked_operator: 'Unlock (Override)',
    access_enabled: 'Access enabled',
    unknown: 'Unknown',
    door_tampered: 'In alarm tampered',
    tampered_lockdown: 'Tampered / Lockdown',
  },
};

export default doors;
